export const appHead = {"meta":[{"charset":"utf-8"},{"name":"charset","content":"utf-8"},{"name":"viewport","content":"width=device-width,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no"},{"name":"description","content":"Create professional resumes effortlessly with RezAI. AI-powered resume builder that enhances your job search success!"},{"name":"keywords","content":"AI resume builder, smart CV generator, online resume maker, AI job application tool, resume optimization, best AI resume generator, AI-powered job search, automated resume writing, resume writing software, how to create a resume with AI"},{"property":"og:title","content":"RezAI - AI-Powered Resume Builder"},{"property":"og:description","content":"Boost your job application success with RezAI, an AI-powered resume creator for professional CVs."},{"property":"og:image","content":"/og.png"},{"property":"og:url","content":"https://rezai.cc"},{"property":"og:type","content":"website"},{"name":"twitter:card","content":"summary_large_image"},{"name":"twitter:title","content":"RezAI - AI Resume Generator"},{"name":"twitter:description","content":"Create AI-optimized resumes effortlessly and land your dream job with RezAI!"},{"name":"twitter:image","content":"/og.png"}],"link":[{"rel":"icon","type":"image/svg+xml","href":"/icon.svg"}],"style":[],"script":[],"noscript":[],"title":"RezAI - AI-Powered Resume Builder"}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = true

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"value":null,"errorValue":null,"deep":true}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = false

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true